


export const labAuxMapper = (dataLab) => {

  const dataCita     = dataLab.atencionMedica.cita;
  const dataPaciente = dataCita.paciente.persona;


  const pacienteMap = {
    identificacion: dataPaciente.identificacion,
    primerApellido: dataPaciente.primerApellido,
    primerNombre  : dataPaciente.primerNombre,
    nombreTexto   : `${dataPaciente.primerApellido} ${dataPaciente.primerNombre}`,
    contacto      : `${dataPaciente.telefono} - ${dataPaciente.correo}`,
  }

  const dataLaboratorios = dataLab.laboratorios;
  const laboratorios = dataLaboratorios ? JSON.parse(dataLab.laboratorios) : [];
  
  const mappedData = {
    id              : dataLab.id,
    token           : dataLab.token,
    fechaCita       : dataCita.fechaCita,
    doctor          : `${dataCita.doctor.idPersona.primerApellido} ${dataCita.doctor.idPersona.primerNombre}`,
    establecimiento : dataCita.establecimiento.Descripcion,
    especialidad    : dataCita.doctor.especialidad.descripcion,
    paciente        : pacienteMap,
    codigoOrden     : dataLab.codigoOrden,
    codigoOrion     : dataLab.codigoOrion,
    esHomologado    : dataLab.estadoHomologado,
    estadoLaboratorio   : dataLab.estadoLaboratorio,
    mspPaciente  : dataLab.urlMspCalificacion,
    mspTitular1  : dataLab.urlMspCalificacion1,
    mspTitular2  : dataLab.urlMspCalificacion2,
    urlInforme     : dataLab.urlInforme,
    fechaResultado : dataLab.fechaResultado,
    // mspTitular3  : dataLab.mspTitular3,

    laboratorios,
  }

  return mappedData
}
